import { Link } from 'react-router'

export default class SidebarMokaLogo extends React.Component {
  render () {
    return (
      <li className='sidebar-brand'>
        <Link to={this.props.link} className='logo-moka-full' >
          <img src={require('assets/images/logo-moka-full.png')} width='103' height='22' />
        </Link>
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/Sidebar/SidebarMokaLogo/SidebarMokaLogo.js